<template>
    <div>
        <div class="row">
            <div class="col-xl-3 col-lg-6">
                <div class="card border-0 bg-dark text-white text-truncate mb-3">
                    <div class="card-body">
                        <div class="mb-3 text-grey">
                            <b class="mb-3">SPACE STATS</b> 
                            <span class="ml-2"><i class="fa fa-info-circle" title="Space stats" v-b-popover.hover="'This is a compilation of space stats'"></i></span>
                        </div>
                        <div class="d-flex mb-2">
                            <div class="d-flex align-items-center">
                                <i class="fa fa-circle text-indigo f-s-8 mr-2"></i>
                                Space items
                            </div>
                            <div class="d-flex align-items-center ml-auto">
                                <div class="width-50 text-right pl-2 f-w-600">{{ spaceCount }}</div>
                            </div>
                        </div>
                        <div class="d-flex mb-2">
                            <div class="d-flex align-items-center">
                                <i class="fa fa-circle text-purple f-s-8 mr-2"></i>
                                Areas
                            </div>
                            <div class="d-flex align-items-center ml-auto">
                                <div class="width-50 text-right pl-2 f-w-600">{{ areas }}</div>
                            </div>
                        </div>
                        <div class="d-flex">
                            <div class="d-flex align-items-center">
                                <i class="fa fa-circle text-pink f-s-8 mr-2"></i>
                                Venues
                            </div>
                            <div class="d-flex align-items-center ml-auto">
                                <div class="width-50 text-right pl-2 f-w-600">{{ venues }}</div>
                            </div>
                        </div>
                        <hr class="bg-white-transparent-2 m-t-20 m-b-20" />
                        <div class="d-flex mb-2">
                            <div class="d-flex align-items-center">
                                <i class="fa fa-circle text-black f-s-8 mr-2"></i>
                                Available
                            </div>
                            <div class="d-flex align-items-center ml-auto">
                                <div class="width-50 text-right pl-2 f-w-600">{{ availableSpaces }}</div>
                            </div>
                        </div>
                        <div class="d-flex mb-2">
                            <div class="d-flex align-items-center">
                                <i class="fa fa-circle text-gray f-s-8 mr-2"></i>
                                Active
                            </div>
                            <div class="d-flex align-items-center ml-auto">
                                <div class="width-50 text-right pl-2 f-w-600">{{ activeSpaces }}</div>
                            </div>
                        </div>
                        <div class="d-flex mb-2">
                            <div class="d-flex align-items-center">
                                <i class="fa fa-circle text-white f-s-8 mr-2"></i>
                                Balance
                            </div>
                            <div class="d-flex align-items-center ml-auto">
                                <div class="width-50 text-right pl-2 f-w-600">{{ balanceSpaces }}</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-xl-3 col-lg-6">
                <div class="card border-0 bg-dark text-white text-truncate mb-3">
                    <div class="card-body">
                        <div class="mb-3 text-grey">
                            <b class="mb-3">STUFF STATS</b> 
                            <span class="ml-2"><i class="fa fa-info-circle" title="Stuff stats" v-b-popover.hover="'This is a compilation of stuff stats'"></i></span>
                        </div>
                        <div class="d-flex mb-2">
                            <div class="d-flex align-items-center">
                                <i class="fa fa-circle text-blue f-s-8 mr-2"></i>
                                Items
                            </div>
                            <div class="d-flex align-items-center ml-auto">
                                <div class="width-50 text-right pl-2 f-w-600">{{ stuffCount }}</div>
                            </div>
                        </div>
                        <div class="d-flex mb-2">
                            <div class="d-flex align-items-center">
                                <i class="fa fa-circle text-aqua f-s-8 mr-2"></i>
                                Subcategories
                            </div>
                            <div class="d-flex align-items-center ml-auto">
                                <div class="width-50 text-right pl-2 f-w-600">{{ subcategories }}</div>
                            </div>
                        </div>
                        <div class="d-flex">
                            <div class="d-flex align-items-center">
                                <i class="fa fa-circle text-teal f-s-8 mr-2"></i>
                                Categories
                            </div>
                            <div class="d-flex align-items-center ml-auto">
                                <div class="width-50 text-right pl-2 f-w-600">{{ stuffCategories }}</div>
                            </div>
                        </div>
                        <hr class="bg-white-transparent-2 m-t-20 m-b-20" />
                        <div class="d-flex mb-2">
                            <div class="d-flex align-items-center">
                                <i class="fa fa-circle text-black f-s-8 mr-2"></i>
                                Available
                            </div>
                            <div class="d-flex align-items-center ml-auto">
                                <div class="width-50 pl-2 f-w-600">{{ availableStuffPcs + ' pcs' }}</div>
                                <div class="width-50 text-right pl-2 f-w-600">{{ availableStuffM + ' m' }}</div>
                            </div>
                        </div>
                        <div class="d-flex mb-2">
                            <div class="d-flex align-items-center">
                                <i class="fa fa-circle text-gray f-s-8 mr-2"></i>
                                Active
                            </div>
                            <div class="d-flex align-items-center ml-auto">
                                <div class="width-50 pl-2 f-w-600">{{ activeStuffPcs + ' pcs' }}</div>
                                <div class="width-50 text-right pl-2 f-w-600">{{ activeStuffM + ' m' }}</div>
                            </div>
                        </div>
                        <div class="d-flex mb-2">
                            <div class="d-flex align-items-center">
                                <i class="fa fa-circle text-white f-s-8 mr-2"></i>
                                Balance
                            </div>
                            <div class="d-flex align-items-center ml-auto">
                                <div class="width-50 pl-2 f-w-600">{{ balanceStuffPcs + ' pcs' }}</div>
                                <div class="width-50 text-right pl-2 f-w-600">{{ balanceStuffM + ' m' }}</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-xl-3 col-lg-6">
                <div class="card border-0 bg-dark text-white text-truncate mb-3">
                    <div class="card-body">
                        <div class="mb-3 text-grey">
                            <b class="mb-3">STAFF STATS</b> 
                            <span class="ml-2"><i class="fa fa-info-circle" title="Staff stats" v-b-popover.hover="'This is a compilation of staff stats'"></i></span>
                        </div>
                        <div class="d-flex mb-2">
                            <div class="d-flex align-items-center">
                                <i class="fa fa-circle text-green f-s-8 mr-2"></i>
                                Staff
                            </div>
                            <div class="d-flex align-items-center ml-auto">
                                <div class="width-50 text-right pl-2 f-w-600">{{ staffCount }}</div>
                            </div>
                        </div>
                        <div class="d-flex mb-2">
                            <div class="d-flex align-items-center">
                                <i class="fa fa-circle text-lime f-s-8 mr-2"></i>
                                Teams
                            </div>
                            <div class="d-flex align-items-center ml-auto">
                                <div class="width-50 text-right pl-2 f-w-600">{{ teams }}</div>
                            </div>
                        </div>
                        <div class="d-flex">
                            <div class="d-flex align-items-center">
                                <i class="fa fa-circle text-yellow f-s-8 mr-2"></i>
                                Groups
                            </div>
                            <div class="d-flex align-items-center ml-auto">
                                <div class="width-50 text-right pl-2 f-w-600">{{ groups }}</div>
                            </div>
                        </div>
                        <hr class="bg-white-transparent-2 m-t-20 m-b-20" />
                        <div class="d-flex mb-2">
                            <div class="d-flex align-items-center">
                                <i class="fa fa-circle text-black f-s-8 mr-2"></i>
                                Available
                            </div>
                            <div class="d-flex align-items-center ml-auto">
                                <div class="width-50 text-right pl-2 f-w-600">{{ availableStaff }}</div>
                            </div>
                        </div>
                        <div class="d-flex mb-2">
                            <div class="d-flex align-items-center">
                                <i class="fa fa-circle text-gray f-s-8 mr-2"></i>
                                Active
                            </div>
                            <div class="d-flex align-items-center ml-auto">
                                <div class="width-50 text-right pl-2 f-w-600">{{ activeStaff }}</div>
                            </div>
                        </div>
                        <div class="d-flex mb-2">
                            <div class="d-flex align-items-center">
                                <i class="fa fa-circle text-white f-s-8 mr-2"></i>
                                Balance
                            </div>
                            <div class="d-flex align-items-center ml-auto">
                                <div class="width-50 text-right pl-2 f-w-600">{{ balanceStaff }}</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-xl-3 col-lg-6">
                <div class="card border-0 bg-dark text-white text-truncate mb-3">
                    <div class="card-body">
                        <div class="mb-3 text-grey">
                            <b class="mb-3">SERVICE STATS</b> 
                            <span class="ml-2"><i class="fa fa-info-circle" title="Service stats" v-b-popover.hover="'This is a compilation of service stats'"></i></span>
                        </div>
                        <div class="d-flex mb-2">
                            <div class="d-flex align-items-center">
                                <i class="fa fa-circle text-red f-s-8 mr-2"></i>
                                Service providers
                            </div>
                            <div class="d-flex align-items-center ml-auto">
                                <div class="width-50 text-right pl-2 f-w-600">{{ serviceCount }}</div>
                            </div>
                        </div>
                        <div class="d-flex mb-2">
                            <div class="d-flex align-items-center">
                                <i class="fa fa-circle text-orange f-s-8 mr-2"></i>
                                Service areas
                            </div>
                            <div class="d-flex align-items-center ml-auto">
                                <div class="width-50 text-right pl-2 f-w-600">{{ serviceAreas }}</div>
                            </div>
                        </div>
                        <div class="d-flex">
                            <div class="d-flex align-items-center">
                                <i class="fa fa-circle text-yellow f-s-8 mr-2"></i>
                                Service Categories
                            </div>
                            <div class="d-flex align-items-center ml-auto">
                                <div class="width-50 text-right pl-2 f-w-600">{{ serviceCategories }}</div>
                            </div>
                        </div>
                        <hr class="bg-white-transparent-2 m-t-20 m-b-20" />
                        <div class="d-flex mb-2">
                            <div class="d-flex align-items-center">
                                <i class="fa fa-circle text-black f-s-8 mr-2"></i>
                                Available
                            </div>
                            <div class="d-flex align-items-center ml-auto">
                                <div class="width-50 text-right pl-2 f-w-600">{{ availableServices }}</div>
                            </div>
                        </div>
                        <div class="d-flex mb-2">
                            <div class="d-flex align-items-center">
                                <i class="fa fa-circle text-gray f-s-8 mr-2"></i>
                                Active
                            </div>
                            <div class="d-flex align-items-center ml-auto">
                                <div class="width-50 text-right pl-2 f-w-600">{{ activeServices }}</div>
                            </div>
                        </div>
                        <div class="d-flex mb-2">
                            <div class="d-flex align-items-center">
                                <i class="fa fa-circle text-white f-s-8 mr-2"></i>
                                Balance
                            </div>
                            <div class="d-flex align-items-center ml-auto">
                                <div class="width-50 text-right pl-2 f-w-600">{{ balanceServices }}</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-xl-3 col-lg-6 mb-3">
                <b-card bg-variant="dark" footer-bg-variant="dark" text-variant="light" title="Space" :img-src="require('@/assets/images/widget/Widget_card_headpics_EB_space.jpg')" img-alt="Image" img-top>
                    <b-card-text>
                        Set Space Main categories (Venue) and sub-categories (Areas) as you wish. 
                        This is how you categorize your specific space items (ie. rooms / specific areas on your master plans) while planning.
                    </b-card-text>
                    <url-button label="Search" :url="'/eventbank/space'" class="btn-yellow" />
                    <url-button label="Add" :url="'/eventbank/space/items/new'" class="btn-gray" />
                    <url-button label="Import" :url="'/eventbank/space/import'" class="btn-white" />
                    <url-button label="Import categories" :url="'/eventbank/space/import/categories'" class="btn-white" />
                </b-card>
            </div>
            <div class="col-xl-3 col-lg-6 mb-3">
                <b-card bg-variant="dark" footer-bg-variant="dark" text-variant="light" title="Stuff" :img-src="require('@/assets/images/widget/Widget_card_headpics_EB_stuff.jpg')" img-alt="Image" img-top>
                    <b-card-text>
                        Set Stuff Main categories (Stuff Main Category) and sub-categories (Stuff item category) as you wish. 
                        This is how you categorize your specific stuff items (products) while planning.
                    </b-card-text>
                    <url-button label="Search" :url="'/eventbank/stuff'" class="btn-yellow" />
                    <url-button label="Add" :url="'/eventbank/stuff/items/new'" class="btn-gray" />
                    <url-button label="Import" :url="'/eventbank/stuff/import'" class="btn-white" />
                    <url-button label="Import categories" :url="'/eventbank/stuff/import/categories'" class="btn-white" />
                </b-card>
            </div>
            <div class="col-xl-3 col-lg-6 mb-3">
                <b-card bg-variant="dark" footer-bg-variant="dark" text-variant="light" title="Staff" :img-src="require('@/assets/images/widget/Widget_card_headpics_EB_staff.jpg')" img-alt="Image" img-top>
                    <b-card-text>
                        Set Staff Main categories (Staff Group) and sub-categories (Staff teams) as you wish. 
                        This is how you categorize your specific staff items  (job titles / persons)  while planning
                    </b-card-text>
                    <url-button label="Search" :url="'/eventbank/staff'" class="btn-yellow" />
                    <url-button label="Add" :url="'/eventbank/staff/items/new'" class="btn-gray" />
                    <url-button label="Import" :url="'/eventbank/staff/import'" class="btn-white" />
                    <url-button label="Import categories" :url="'/eventbank/staff/import/categories'" class="btn-white" />
                </b-card>
            </div>
            <div class="col-xl-3 col-lg-6 mb-3">
                <b-card bg-variant="dark" footer-bg-variant="dark" text-variant="light" title="Service" :img-src="require('@/assets/images/widget/Widget_card_headpics_EB_service.jpg')" img-alt="Image" img-top>
                    <b-card-text>
                        Set Support Service Main categories (Service category) and sub-categories (Service Areas) as you wish. 
                        This is how you categorize your specific support items (service providers).
                    </b-card-text>
                    <url-button label="Search" :url="'/eventbank/service'" class="btn-yellow" />
                    <url-button label="Add" :url="'/eventbank/service/items/new'" class="btn-gray" />
                    <url-button label="Import" :url="'/eventbank/service/import'" class="btn-white" />
                    <url-button label="Import categories" :url="'/eventbank/service/import/categories'" class="btn-white" />
                </b-card>
            </div>
        </div>
        <div class="row">
            <div class="col-xl-6 col-lg-6 mb-3">
                <b-card bg-variant="dark" text-variant="light" title="Import">
                    <b-card-text>
                        Import items
                    </b-card-text>
                    <url-button label="Import" :url="'/eventbank/import'" class="btn-white" />
                    <url-button label="Import categories" :url="'/eventbank/import/categories'" class="btn-white" />
                </b-card>
            </div>
            <div class="col-xl-6 col-lg-6">
                <b-card bg-variant="dark" text-variant="light" title="Tooltip">
                    <b-card-text>
                        Three main things to do here:
                        <ol>
                            <li>Set your way to organize your space, stuff, staff and support service resources</li>
                            <li>Bring in your own resources and way you organize your space, stuff, staff and support service items in real.</li>
                            <li>#3 Or take a shortcut and use elements, we have brought in to this app.</li>
                        </ol>
                    </b-card-text>
                </b-card>
            </div>
        </div>
    </div>
</template>

<script>

import UrlButton from '../buttons/UrlButton.vue'

export default {
    name: 'EventBankMain',
    props: ['items', 'categories', 'scriptItems'],
    components: {
        UrlButton
    },
    data() {
        return {
            loaded: false,
            serviceCount: 0,
            serviceAreas: 0,
            serviceCategories: 0,
            spaceCount: 0,
            areas: 0,
            venues: 0,
            staffCount: 0,
            teams: 0,
            groups: 0,
            stuffCount: 0,
            subcategories: 0,
            stuffCategories: 0,
            availableSpaces: 0,
            availableStuffPcs: 0,
            availableStuffM: 0,
            availableStaff: 0,
            availableServices: 0,
            activeSpaces: 0,
            activeStuffPcs: 0,
            activeStuffM: 0,
            activeStaff: 0,
            activeServices: 0,
            balanceSpaces: 0,
            balanceStuffPcs: 0,
            balanceStuffM: 0,
            balanceStaff: 0,
            balanceServices: 0
        }
    },
    methods: {
        getBankCounts() {
            let totalSpaces = 0,
                totalStuffPcs = 0,
                totalStuffM = 0,
                totalStaff = 0,
                totalServices = 0;
            this.items.forEach(item => {
                let currentAmountInUse = 0;
                this.scriptItems.forEach(scriptItem => {
                    if (scriptItem.item.id == item.id) {
                        currentAmountInUse += scriptItem.amount;
                        switch (item.type.id) {
                            case 1:
                                this.activeServices += scriptItem.amount;
                                break;
                            case 2:
                                this.activeSpaces += scriptItem.amount;
                                break;
                            case 3:
                                this.activeStaff += scriptItem.amount;
                                break;
                            case 4:
                                if (item.unit == "m") {
                                    this.activeStuffM += scriptItem.amount;
                                } else {
                                    this.activeStuffPcs += scriptItem.amount;
                                }
                                break;
                            default:
                                break;
                        }
                    }
                });
                let currentItemBalance = item.amount - currentAmountInUse;
                if (currentItemBalance > 0) {
                    switch (item.type.id) {
                        case 1:
                            this.availableServices += currentItemBalance;
                            break;
                        case 2:
                            this.availableSpaces += currentItemBalance;
                            break;
                        case 3:
                            this.availableStaff += currentItemBalance;
                            break;
                        case 4:
                            if (item.unit == "m") {
                                this.availableStuffM += currentItemBalance;
                            } else {
                                this.availableStuffPcs += currentItemBalance;
                            }
                            break;
                    }
                }
                switch (item.type.id) {
                    case 1:
                        this.serviceCount++;
                        totalServices += item.amount;
                        break;
                    case 2:
                        this.spaceCount++;
                        totalSpaces += item.amount;
                        break;
                    case 3:
                        this.staffCount++;
                        totalStaff += item.amount;
                        break;
                    case 4:
                        this.stuffCount++;
                        if (item.unit == 'm') {
                            totalStuffM += item.amount;
                        } else {
                            totalStuffPcs += item.amount;
                        }
                        break;
                    default:
                        break;
                }
            });
            this.balanceServices = totalServices - this.activeServices;
            this.balanceSpaces = totalSpaces - this.activeSpaces;
            this.balanceStaff = totalStaff - this.activeStaff;
            this.balanceStuffM = totalStuffM - this.activeStuffM;
            this.balanceStuffPcs = totalStuffPcs - this.activeStuffPcs;

            this.categories.forEach(category => {
                if (category.parent) {
                    switch (category.type.id) {
                        case 1:
                            this.serviceAreas++;
                            break;
                        case 2:
                            this.areas++;
                            break;
                        case 3:
                            this.teams++;
                            break;
                        case 4:
                            this.subcategories++;
                            break;
                        default:
                            break;
                    }
                } else {
                    switch (category.type.id) {
                        case 1:
                            this.serviceCategories++;
                            break;
                        case 2:
                            this.venues++;
                            break;
                        case 3:
                            this.groups++;
                            break;
                        case 4:
                            this.stuffCategories++;
                            break;
                        default:
                            break;
                    }
                }
            });
        }
    },
    watch: {
        categories: function () {
            if (!this.loaded) {
                this.getBankCounts();
                this.loaded = true;
            }
        }
    }
}
</script>